import { site } from '@yola/ws-sdk';
import showEditor from '../actions/show-editor';

const initialEditorRender = (store) => (next) => (action) => {
  next(action);

  if (action.type === site.actionTypes.CONNECT_SITE) {
    const state = store.getState();
    const { mainLocale } = action.payload.site.meta;

    const activePage =
      site.selectors.getActivePageId(state) || site.selectors.getHomePage(state, mainLocale).id;

    store.dispatch(site.actions.setActivePage(activePage));

    store.dispatch(showEditor());
  }
};

export default initialEditorRender;
